import axios from "axios";
import qs from "qs";
//Traer todos los cursos con el limite y desde que registro
export const getIva = async () => {
  let url = `https://backdistripruebas.us-3.evennode.com/iva`;
  const options = {
    method: "GET",
    headers: {
      "content-type": "application/x-www-form-urlencoded",
    },
  };
  try {
    const resp = await axios(url, options);
    const { data } = resp;
    return data;
  } catch (error) {
    return {
      data: error.response.data,
      loading: false,
    };
  }
};
//Traer un curso según su id
export const getIvaId = async (id) => {
  let url = `https://backdistripruebas.us-3.evennode.com/iva/${id}`;
  const options = {
    method: "GET",
    headers: {
      "content-type": "application/x-www-form-urlencoded",
    },
  };
  try {
    const resp = await axios(url, options);
    const { data } = resp;
    return data;
  } catch (error) {
    return {
      data: error.response.data,
      loading: false,
    };
  }
};
